import { BonusPoints } from '../basket-checkout-common/BonusPoints.js';
import { Tracking } from '../shared/Tracking';
import { Feature } from '@otto-ec/tracking-bct';
import { onMount } from '@otto-ec/global-resources/dom';

export class EmployeeBonusPoints {
    constructor(
        private readonly _bonusPoints: BonusPoints,
        private readonly _tracking: Tracking
    ) {
        this.registerRedeemChangeHandler();
        this.registerRowClickHandler();
    }

    registerRedeemChangeHandler() {
        onMount<HTMLOcCheckboxV2Element>('.or_js_bonusPoints__checkbox', checkboxV2 => {
            const checkbox = checkboxV2.querySelector<HTMLInputElement>("input[type='checkbox']")!;
            checkbox.addEventListener('change', async () => {
                if (checkbox.disabled) {
                    return;
                }

                const toBeRedeemed = checkbox.checked ? (checkboxV2.dataset.redeemable ?? '0') : '0';
                await this._bonusPoints
                    .redeemBonusPointsAndReload(toBeRedeemed)
                    .then(() => checkboxV2.querySelector("[slot='error']")?.remove())
                    .catch(() => this._handleRedemptionError(checkbox, checkboxV2));
            });
        });
    }

    /**
 *
 *
 */
    registerRowClickHandler() {
        onMount<HTMLOcRowV2Element>('.or_js_bonusPoints__employee', bonusPointsEmployeeRow => {
            const checkboxV2 = bonusPointsEmployeeRow.querySelector<HTMLOcCheckboxV2Element>('.or_js_bonusPoints__checkbox')!;
            const checkbox = checkboxV2.querySelector<HTMLInputElement>("input[type='checkbox']")!;

            bonusPointsEmployeeRow.addEventListener('click', event => {
                if (checkbox.disabled || event.composedPath().includes(checkboxV2)) {
                    return;
                }

                checkbox.click();
            });
        });
    }

    _handleRedemptionError(checkbox: HTMLInputElement, checkboxV2: HTMLOcCheckboxV2Element) {
        if (checkboxV2.querySelector("[slot='error']") === null) {
            const errorSlot = document.createElement('span');
            errorSlot.setAttribute('slot', 'error');
            errorSlot.innerText = 'Bei uns ist ein technischer Fehler aufgetreten. Bitte versuche es erneut.';
            checkboxV2.appendChild(errorSlot);
        }

        checkbox.checked = !checkbox.checked;

        this._tracking.submitEvent({
            name: 'submit',
            features: [this._orderMessageFeature(BonusPoints.REDEMPTION_ERROR_MESSAGE_ID + '.checkbox')]
        });
    }

    _orderMessageFeature(errorMessageId: string): Feature {
        return {
            id: 'order_message',
            name: 'OrderMessage',
            status: 'visible',
            labels: {
                order_ErrorMessage: [errorMessageId]
            }
        };
    }
}
